import * as React from 'react';
import { RouteComponentProps , withRouter} from 'react-router-dom';
import { Button, Col,  Container, FormGroup, Label, Modal  , Row} from 'reactstrap';
import { IGlobalContextProps, withGlobalContext } from 'src/context/global.context';
import { Svg } from '../Svg';

interface ISignupConfirmationModalProps {
  isOpen: boolean;
  toggleSignupConfirmationModal: () => void;
}

 const SignupConfirmationModal: React.SFC< 
  ISignupConfirmationModalProps & IGlobalContextProps & RouteComponentProps
> = ({ history , isOpen, context , toggleSignupConfirmationModal }) => {
  const { user } = context;
  

  const doClick = () => {
  toggleSignupConfirmationModal()
  if(user && user.type === 'consultant'){
    history.push('/profile/')
  }
  }


  return (
    <Modal className='position-relative' isOpen={isOpen}>
      <Svg
        className='position-absolute'
        fill='primary'
        width={280}
        height={210}
        opacity={0.1}
        src='bulle-popin'
        style={{ top: '-19px', left: '-15px' }}
      />
      <div className='d-flex justify-content-end p-3'>
        <Svg
          fill='dark'
          src='close'
          width={16}
          onClick={toggleSignupConfirmationModal}
        />
      </div>
      <Container className='px-0' >
        <FormGroup>
          { user ?   
                  (user.type === 'client' ?  
                  <Label className='d-flex flex-column'>
                    <h4 className='mx-4 align-self-center' >Merci de nous faire confiance!</h4>
                    <br/>
                    <br/>
                    <p className='mx-5'>Vous allez bientôt recevoir un email pour valider votre compte.</p>
                    <p className='mx-5'>Un de nos conseillers vous contactera sous peu pour affiner votre besoin.</p>
                  </Label>
                  : 
                  <Label className='d-flex flex-column'>
                    <h4 className='mx-4 align-self-center' >Merci d'avoir rejoint la communauté BeAdvize !</h4>
                    <br/>
                    <br/>
                    <p className='mx-5'>Vous allez bientôt recevoir un email pour valider votre compte.</p>
                    <p className='mx-5'>Un de nos conseillers vous contactera sous peu pour affiner votre recherche.</p>
                  </Label> 
                  )
            :
          <Label>
          <h4 className='mx-4 align-self-center' >Merci de votre inscription  <br/>On vous contacte au plus vite ! </h4>
          </Label>

      }
          <Row className='d-flex justify-content-center'>
            <Col  xs='4'>
              <Button className='text-uppercase text-white bg-primary w-100 border-0 mt-3' onClick={doClick}>OK</Button>
            </Col>
          </Row>
        </FormGroup>
      </Container>
    </Modal>
  );
};


export const SignupConfirmationModalWithGlobalContext = withGlobalContext(
  withRouter(SignupConfirmationModal)
);



// WEBPACK FOOTER //
// ./src/components/shared/Modals/SignupConfirmationModal.tsx